import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { InfoCards, retentionTooltipIcons, stackedBarLegendItems } from "../../_models";
import {
  BarChartType,
  CardLoaderSize,
  DoughnutChartData,
  InlineTableData,
  PerfTableColumn,
  retentionValueCols,
} from "../data-visualization";
import { DashboardTabAbstractComponent } from "../dashboard-tab-abstract.component";
import {
  SubscriptionInfo,
  canceledWithPendingOrderData,
  subscriptionBillingCycleData,
  subscriptionCampaignData,
  subscriptionCancellationReasons,
  subscriptionCustomerStageData,
  subscriptionDoughnutData,
  subscriptionFrequencyData,
  subscriptionHints,
  subscriptionOfferTypeData,
  subscriptionProductData,
  subscriptionSummaryTableData,
  subscriptionTopCards,
} from "./subscription.data";
import { ProductViewType } from "../orders/orders.data";
import { ReportDimensions } from "../../reports/models/reports";

@Component({
  selector: "app-subscription-dashboard",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./../dashboard-section.scss", "./../dashboard-section-v2.scss"],
})
export class DashboardSubscriptionComponent extends DashboardTabAbstractComponent implements OnInit {
  @Input() cardsLoading: boolean = false;
  @Output() reportNavigate = new EventEmitter<string>();

  /* Cards Data */
  subscriptionTopCards: InfoCards = subscriptionTopCards;
  subscriptionInfo = SubscriptionInfo;

  /* Charts Data */
  subscriptionDoughnutData: DoughnutChartData = subscriptionDoughnutData;
  subscriptionSummaryTableData: InlineTableData = subscriptionSummaryTableData;
  cancellationReasons = subscriptionCancellationReasons;
  offerTypeData = subscriptionOfferTypeData;
  productData = subscriptionProductData;
  billingCycleData = subscriptionBillingCycleData;
  frequencyData = subscriptionFrequencyData;
  campaignData = subscriptionCampaignData;
  customerStageData = subscriptionCustomerStageData;

  /* Canceled With Pending Order */
  canceledWithPendingOrderData = canceledWithPendingOrderData;

  /* Misc */
  subscriptionHints = subscriptionHints;
  retentionTooltipIcons = retentionTooltipIcons;
  stackedBarLegendItems = stackedBarLegendItems;
  barChartType = BarChartType;
  cardLoaderSize = CardLoaderSize;
  productViewTypeEnum = ProductViewType;
  productViewType: ProductViewType = ProductViewType.Base;
  reportDimensions = ReportDimensions;

  /* Perf table column definitions */
  offerTypeNameCol: PerfTableColumn = { label: 'Offer Type', field: 'name' };
  offerTypeValueCols = retentionValueCols;
  productNameCol: PerfTableColumn = { label: 'Product Name', field: 'name' };
  productValueCols = retentionValueCols;
  campaignNameCol: PerfTableColumn = { label: 'Name', field: 'name' };
  campaignValueCols = retentionValueCols;
  customerStageNameCol: PerfTableColumn = { label: 'Name', field: 'name' };
  customerStageValueCols = retentionValueCols;

  get showCanceledWithPendingOrder(): boolean {
    return this.canceledWithPendingOrderData.show;
  }

  get canceledWithPendingOrderMetrics(): { label: string; value: string }[] {
    const d = this.canceledWithPendingOrderData;
    return [
      { label: 'Quantity', value: d.quantity },
      { label: 'Subscription Value Lost', value: d.subscriptionValueLost },
      { label: 'Cancellation Rate', value: d.cancellationRate },
      { label: 'Cycle 1 / Initial', value: d.cycle1Quantity + ' / ' + d.cycle1Value },
      { label: 'Cycle 2+ / Rebill', value: d.cycle2Quantity + ' / ' + d.cycle2Value },
      { label: 'Avg. Value', value: d.avgValue },
    ];
  }

  constructor() {
    super();
  }

  ngOnInit() {}

  navigateToReport(dimension: string) {
    this.reportNavigate.emit(dimension);
  }

  onProductViewTypeChange(type: ProductViewType) {
    this.productViewType = type;
    this.productData.type = type;
    if (type === ProductViewType.Base) {
      if (this.productData.baseData !== null) {
        this.productData.data = this.productData.baseData;
        this.productData.noData = this.productData.baseData.length === 0;
        this.productData.loading = false;
      } else {
        this.productData.loading = true;
      }
    } else {
      if (this.productData.campaignData !== null) {
        this.productData.data = this.productData.campaignData;
        this.productData.noData = this.productData.campaignData.length === 0;
        this.productData.loading = false;
      } else {
        this.productData.loading = true;
      }
    }
  }
}
